import ngeohash from "ngeohash";

/**
 * Encode latitude/longitude into a geohash string.
 * Default precision 4 gives ~39km × 20km cells — suitable for "near you" notifications.
 */
export function encodeGeohash(
  lat: number,
  lng: number,
  precision: number = 4
): string {
  return ngeohash.encode(lat, lng, precision);
}

/** Return the 8 neighboring geohash cells surrounding the given hash. */
export function geohashNeighbors(hash: string): string[] {
  return ngeohash.neighbors(hash);
}

/** Return the given hash plus its 8 neighbors (9 cells total). */
export function geohashWithNeighbors(hash: string): string[] {
  return [hash, ...ngeohash.neighbors(hash)];
}
